import { cn } from '@forest/shared'

// Hourglass glyph for the hero card's countdown pill.
// 18px unless the caller's `class` sizes it; fills with `currentColor` so it
// follows the surrounding text colour.
export function CountdownIcon(props: { class?: string }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 18 18"
      fill="none"
      class={cn('size-[18px]', props.class)}
    >
      <path
        d="M13.4053 13.8923H13.2181V13.5026C13.2181 11.8 12.0947 10.1692 10.1013 8.95897C10.5198 8.70256 10.8943 8.4359 11.2357 8.14872C12.5352 7.05128 13.2181 5.75897 13.2181 4.41538V4.10769H13.4053C13.7357 4.10769 14 3.86154 14 3.55385C14 3.24615 13.7357 3 13.4053 3H4.59471C4.26432 3 4 3.24615 4 3.55385C4 3.86154 4.26432 4.10769 4.59471 4.10769H4.7489V4.41538C4.7489 6.11795 5.87225 7.74872 7.86564 8.95897C7.44714 9.21538 7.07269 9.48205 6.73128 9.76923C5.43172 10.8667 4.7489 12.159 4.7489 13.5026V13.8923H4.59471C4.26432 13.8923 4 14.1385 4 14.4462C4 14.7538 4.26432 15 4.59471 15H13.4053C13.7357 15 14 14.7538 14 14.4462C14 14.1385 13.7357 13.8923 13.4053 13.8923ZM6.02643 4.41538V4.10769H11.9405V4.41538C11.9405 5.47179 11.3899 6.49744 10.3326 7.38974C9.94714 7.7282 9.49559 8.02564 8.97797 8.30256C7.09471 7.27692 6.01542 5.87179 6.02643 4.41538ZM5.92731 13.6359C5.92731 12.5487 6.5 11.4923 7.59031 10.5692C7.78855 10.3949 8.00881 10.2308 8.24009 10.0667C8.24009 10.0667 8.24009 10.0667 8.2511 10.0667C8.48238 9.91282 8.71366 9.76923 8.96696 9.6359C9.93612 10.1692 10.696 10.7949 11.2247 11.4718C11.7423 12.159 12.0176 12.8872 12.0176 13.6462V13.9128H5.9163V13.6462L5.92731 13.6359Z"
        fill="currentColor"
      />
    </svg>
  )
}
